import styled from 'styled-components';

export const ButtonContain = styled.div`
  margin: ${props => props.margin || '7px 0'};
  .ant-btn {
    border-radius: 7px;
    align-items: center;
    font-weight: 400;
    transition-delay: 0.1s;
    transition-property: background-color, color;
    box-shadow: 0 2px 3px rgb(0 0 0 / 28%);
  }
`;
